(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-verifier"] && !Shopify.designMode) return;
  try {
    
(function () {
  var el = document.querySelector('[data-age-gate]');
  if (!el) return;
  var KEY = 'age_verified';
  try {
    var until = localStorage.getItem(KEY);
    if (until === 'session') {
      if (sessionStorage.getItem(KEY)) return;
    } else if (until && Date.now() < parseInt(until, 10)) {
      return;
    }
  } catch (e) {}

  el.hidden = false;
  document.documentElement.style.overflow = 'hidden';

  function remember() {
    var days = parseFloat(el.getAttribute('data-age-remember'));
    try {
      if (!days || days <= 0) { sessionStorage.setItem(KEY, '1'); localStorage.setItem(KEY, 'session'); }
      else { localStorage.setItem(KEY, '' + (Date.now() + days * 86400000)); }
    } catch (e) {}
  }
  el.querySelector('[data-age-confirm]').addEventListener('click', function () {
    remember();
    el.hidden = true;
    document.documentElement.style.overflow = '';
  });
  el.querySelector('[data-age-decline]').addEventListener('click', function () {
    window.location.href = el.getAttribute('data-age-deny');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(el) {
    var before = el.querySelector('[data-ba-before]');
    var range = el.querySelector('[data-ba-range]');
    if (!before || !range) return;
    function update() {
      var pos = range.value + '%';
      el.style.setProperty('--ba-pos', pos);
    }
    range.addEventListener('input', update);
    update();
  }
  document.querySelectorAll('[data-beforeafter]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-cards"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.ccReady === '1') return;
    root.dataset.ccReady = '1';
    var track = root.querySelector('[data-cc-track]');
    if (!track) return;
    var prev = root.querySelector('[data-cc-prev]');
    var next = root.querySelector('[data-cc-next]');
    var dotsWrap = root.querySelector('[data-cc-dots]');

    function stepWidth() {
      var a = track.children[0];
      if (!a) return track.clientWidth;
      var b = track.children[1];
      return b ? (b.offsetLeft - a.offsetLeft) : a.offsetWidth;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepWidth(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: stepWidth(), behavior: 'smooth' }); });

    var dots = [];
    if (dotsWrap) {
      for (var i = 0; i < track.children.length; i++) {
        (function (idx) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'catcards__dot';
          d.setAttribute('aria-label', 'Go to item ' + (idx + 1));
          d.addEventListener('click', function () {
            var c = track.children[idx];
            if (c) track.scrollTo({ left: c.offsetLeft - track.children[0].offsetLeft, behavior: 'smooth' });
          });
          dotsWrap.appendChild(d);
          dots.push(d);
        })(i);
      }
    }

    function refresh() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      if (dots.length) {
        var idx = Math.round(track.scrollLeft / (stepWidth() || 1));
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }
    }
    track.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);

    var down = false, sx = 0, sl = 0;
    track.addEventListener('pointerdown', function (e) { down = true; sx = e.clientX; sl = track.scrollLeft; track.classList.add('is-drag'); });
    window.addEventListener('pointermove', function (e) { if (down) track.scrollLeft = sl - (e.clientX - sx); });
    window.addEventListener('pointerup', function () { down = false; track.classList.remove('is-drag'); });

    refresh();
  }
  function all() { document.querySelectorAll('[data-catcards]').forEach(init); }
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function tick(el) {
    var end = new Date(el.getAttribute('data-countdown-end')).getTime();
    if (isNaN(end)) return;
    var now = Date.now();
    var diff = end - now;
    if (diff <= 0) {
      var msg = el.getAttribute('data-countdown-expired') || '';
      el.innerHTML = '<div class="countdown__expired">' + msg + '</div>';
      return true;
    }
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var set = function (sel, val) { var n = el.querySelector(sel); if (n) n.textContent = pad(val); };
    set('[data-cd-days]', d); set('[data-cd-hours]', h); set('[data-cd-mins]', m); set('[data-cd-secs]', s);
    return false;
  }
  function init(el) {
    if (tick(el)) return;
    var id = setInterval(function () { if (tick(el)) clearInterval(id); }, 1000);
  }
  document.querySelectorAll('[data-countdown]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(stage) {
    var spots = stage.querySelectorAll('[data-spot-toggle]');
    function closeAll(except) {
      stage.querySelectorAll('[data-spot-card]').forEach(function (c) { if (c !== except) c.hidden = true; });
    }
    spots.forEach(function (btn) {
      var card = btn.parentNode.querySelector('[data-spot-card]');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = card.hidden;
        closeAll(card);
        card.hidden = !willOpen;
      });
    });
    document.addEventListener('click', function (e) { if (!stage.contains(e.target)) closeAll(null); });
  }
  document.querySelectorAll('[data-lookbook]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-branches"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBranchesSection() {
    var section = document.querySelector('[data-branches-section]');
    if (!section || section.dataset.branchesReady === 'true') return;
    section.dataset.branchesReady = 'true';

    var searchInput = section.querySelector('[data-branches-search]');
    var clearBtn = section.querySelector('[data-branches-search-clear]');
    var filterBtns = section.querySelectorAll('[data-city-filter]');
    var cards = section.querySelectorAll('[data-branch-card]');
    var emptyBox = section.querySelector('[data-branches-empty]');
    var resetBtn = section.querySelector('[data-branches-reset]');
    var toast = section.querySelector('[data-branches-toast]');
    var toastMsg = section.querySelector('[data-toast-msg]');

    var activeCity = 'all';
    var searchQuery = '';

    function filterBranches() {
      var visibleCount = 0;
      var q = searchQuery.toLowerCase().trim();

      cards.forEach(function (card) {
        var cardCity = (card.getAttribute('data-city') || '').toLowerCase();
        var cardKeywords = (card.getAttribute('data-keywords') || '').toLowerCase();

        var matchesCity = (activeCity === 'all' || cardCity === activeCity);
        var matchesSearch = (!q || cardKeywords.indexOf(q) !== -1);

        if (matchesCity && matchesSearch) {
          card.style.display = '';
          visibleCount++;
        } else {
          card.style.display = 'none';
        }
      });

      if (emptyBox) {
        emptyBox.style.display = visibleCount === 0 ? 'block' : 'none';
      }
    }

    // Search input handler
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        searchQuery = searchInput.value;
        if (clearBtn) {
          clearBtn.style.display = searchQuery.length > 0 ? 'block' : 'none';
        }
        filterBranches();
      });
    }

    // Clear search
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        searchInput.value = '';
        searchQuery = '';
        clearBtn.style.display = 'none';
        searchInput.focus();
        filterBranches();
      });
    }

    // City filter pills
    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var city = btn.getAttribute('data-city-filter').toLowerCase();
        activeCity = city;

        filterBtns.forEach(function (b) {
          var isCurrent = b === btn;
          b.classList.toggle('is-active', isCurrent);
          b.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
        });

        filterBranches();
      });
    });

    // Reset button
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        activeCity = 'all';
        searchQuery = '';
        if (searchInput) searchInput.value = '';
        if (clearBtn) clearBtn.style.display = 'none';

        filterBtns.forEach(function (b) {
          var isAll = b.getAttribute('data-city-filter') === 'all';
          b.classList.toggle('is-active', isAll);
          b.setAttribute('aria-selected', isAll ? 'true' : 'false');
        });

        filterBranches();
      });
    }

    // Toast notification
    function showToast(message) {
      if (!toast) return;
      if (toastMsg && message) {
        toastMsg.textContent = message;
      }
      toast.style.display = 'inline-flex';
      setTimeout(function () {
        toast.style.display = 'none';
      }, 2500);
    }

    function fallbackCopy(text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
      } catch (err) {}
      document.body.removeChild(ta);
    }

    // Copy address button
    section.addEventListener('click', function (e) {
      var copyBtn = e.target.closest('[data-copy-address]');
      if (!copyBtn) return;
      e.preventDefault();

      var card = copyBtn.closest('[data-branch-card]');
      if (!card) return;
      var textEl = card.querySelector('[data-address-text]');
      if (!textEl) return;

      var textToCopy = textEl.textContent.trim();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy).then(function () {
          showToast('Address copied to clipboard!');
        }).catch(function () {
          fallbackCopy(textToCopy);
          showToast('Address copied to clipboard!');
        });
      } else {
        fallbackCopy(textToCopy);
        showToast('Address copied to clipboard!');
      }
    });

    // Share branch address & location
    section.addEventListener('click', function (e) {
      var shareBtn = e.target.closest('[data-share-branch]');
      if (!shareBtn) return;
      e.preventDefault();

      var title = shareBtn.getAttribute('data-share-title') || 'Store Location';
      var text = shareBtn.getAttribute('data-share-text') || '';
      var url = shareBtn.getAttribute('data-share-url') || window.location.href;

      if (navigator.share) {
        navigator.share({
          title: title,
          text: title + ' - ' + text,
          url: url
        }).catch(function () {});
      } else {
        var shareContent = title + '\nAddress: ' + text + '\nGoogle Maps: ' + url;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(shareContent).then(function () {
            showToast('Branch location copied to share!');
          }).catch(function () {
            fallbackCopy(shareContent);
            showToast('Branch location copied to share!');
          });
        } else {
          fallbackCopy(shareContent);
          showToast('Branch location copied to share!');
        }
      }
    });
  }

  if (document.readyState !== 'loading') initBranchesSection();
  else document.addEventListener('DOMContentLoaded', initBranchesSection);
  document.addEventListener('shopify:section:load', initBranchesSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  function ready(el) {
    var key = 'newsletter_popup_' + (el.getAttribute('data-popup-id') || 'default');
    function remember() { try { localStorage.setItem(key, '' + (Date.now() + (parseFloat(el.getAttribute('data-popup-days')) || 7) * 86400000)); } catch (e) {} }
    try { var until = localStorage.getItem(key); if (until && Date.now() < parseInt(until, 10)) return; } catch (e) {}
    var delay = (parseFloat(el.getAttribute('data-popup-delay')) || 0) * 1000;
    function open() { el.hidden = false; document.documentElement.style.overflow = 'hidden'; }
    function close() { el.hidden = true; document.documentElement.style.overflow = ''; remember(); }
    setTimeout(open, delay);
    el.querySelectorAll('[data-popup-close]').forEach(function (b) { b.addEventListener('click', close); });
    var form = el.querySelector('form');
    if (form) form.addEventListener('submit', remember);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(); });
  }
  document.querySelectorAll('[data-newsletter-popup]').forEach(ready);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-products-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  // Reads scroll position within the section to decide which slide is
  // currently on top, and crossfades the matching card content to match.
  // The background rise-from-below effect itself is pure CSS (sticky stack).
  function init(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.parallax-banner__bg-slide'));
    var contents = Array.prototype.slice.call(root.querySelectorAll('[data-parallax-content]'));
    var count = slides.length;
    if (!count) return;
    var ticking = false;

    function update() {
      var rect = root.getBoundingClientRect();
      var slideH = slides[0].offsetHeight || 1;
      var scrolled = Math.max(0, -rect.top);
      var idx = Math.min(count - 1, Math.floor(scrolled / slideH));
      contents.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }
  function initAll() {
    document.querySelectorAll('.parallax-banner').forEach(init);
  }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Mobile accordion toggles with event delegation */
  document.addEventListener('click', function (e) {
    var acc = e.target.closest('.ptabs__acc');
    if (!acc) return;
    var panel = acc.closest('.ptabs__panel');
    if (!panel) return;
    var open = panel.hasAttribute('hidden');
    if (open) {
      panel.removeAttribute('hidden');
      acc.setAttribute('aria-expanded', 'true');
      if (window.jdgm) {
        try {
          if (typeof window.jdgm.renderReviewWidget === 'function') window.jdgm.renderReviewWidget();
          else if (typeof window.jdgm.renderWidgets === 'function') window.jdgm.renderWidgets();
          else if (typeof window.jdgm.init === 'function') window.jdgm.init();
        } catch (err) {}
      }
    } else {
      panel.setAttribute('hidden', '');
      acc.setAttribute('aria-expanded', 'false');
    }
  });

  /* Judge.me reviews check & fallback handling */
  function updateJdgmFallback() {
    var widget = document.getElementById('judgeme_product_reviews');
    var fallback = document.querySelector('[data-jdgm-fallback]');
    if (!widget || !fallback) return;

    var revWidg = widget.querySelector('.jdgm-rev-widg');
    if (!revWidg) {
      // Judge.me has not rendered reviews yet
      fallback.style.display = 'block';
      return;
    }

    var countAttr = revWidg.getAttribute('data-number-of-reviews');
    var hasReviews = widget.querySelectorAll('.jdgm-rev').length > 0;
    var formOpen = widget.querySelector('.jdgm-form-wrapper:not([style*="display: none"]), .jdgm-form:not([style*="display: none"])');

    if ((countAttr !== null && parseInt(countAttr, 10) > 0) || hasReviews) {
      // Reviews exist! Show reviews
      fallback.style.display = 'none';
      widget.style.display = 'block';
    } else if (formOpen) {
      // Review form is open, show widget
      fallback.style.display = 'none';
      widget.style.display = 'block';
    } else {
      // No reviews yet, show fallback Submit Review card
      fallback.style.display = 'block';
    }
  }

  // Handle "Submit Review" button click
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-trigger-jdgm-review-form]');
    if (!btn) return;
    e.preventDefault();

    var widget = document.getElementById('judgeme_product_reviews');
    var fallback = document.querySelector('[data-jdgm-fallback]');
    if (widget) {
      widget.style.display = 'block';
    }

    var writeBtn = document.querySelector('#judgeme_product_reviews .jdgm-write-rev-link, #judgeme_product_reviews .jdgm-btn--write-review, .jdgm-write-rev-link');
    if (writeBtn) {
      writeBtn.click();
      if (fallback) fallback.style.display = 'none';
      setTimeout(function () {
        var form = document.querySelector('#judgeme_product_reviews .jdgm-form-wrapper, #judgeme_product_reviews .jdgm-form');
        if (form) {
          form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }, 150);
    } else if (window.jdgm && typeof window.jdgm.openReviewForm === 'function') {
      window.jdgm.openReviewForm();
      if (fallback) fallback.style.display = 'none';
    } else {
      // Try initializing Judge.me
      if (window.jdgm) {
        try {
          if (typeof window.jdgm.renderReviewWidget === 'function') window.jdgm.renderReviewWidget();
          else if (typeof window.jdgm.renderWidgets === 'function') window.jdgm.renderWidgets();
          else if (typeof window.jdgm.init === 'function') window.jdgm.init();
        } catch (err) {}
      }
      setTimeout(function () {
        var retryBtn = document.querySelector('#judgeme_product_reviews .jdgm-write-rev-link, #judgeme_product_reviews .jdgm-btn--write-review, .jdgm-write-rev-link');
        if (retryBtn) {
          retryBtn.click();
          if (fallback) fallback.style.display = 'none';
        }
      }, 350);
    }
  });

  // Observe Judge.me DOM mutations
  function observeJdgm() {
    var widget = document.getElementById('judgeme_product_reviews');
    if (!widget) return;
    updateJdgmFallback();
    if (window.MutationObserver) {
      var observer = new MutationObserver(function () {
        updateJdgmFallback();
      });
      observer.observe(widget, { childList: true, subtree: true, attributes: true });
    }
  }

  if (document.readyState !== 'loading') {
    observeJdgm();
  } else {
    document.addEventListener('DOMContentLoaded', observeJdgm);
  }
  document.addEventListener('shopify:section:load', observeJdgm);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  function ready(el) {
    var key = 'promo_popup_' + (el.getAttribute('data-popup-id') || 'default');
    try {
      var until = localStorage.getItem(key);
      if (until && Date.now() < parseInt(until, 10)) return;
    } catch (e) {}
    var delay = (parseFloat(el.getAttribute('data-popup-delay')) || 0) * 1000;
    var days = parseFloat(el.getAttribute('data-popup-days')) || 7;
    function open() { el.hidden = false; }
    function close() {
      el.hidden = true;
      try { localStorage.setItem(key, '' + (Date.now() + days * 86400000)); } catch (e) {}
    }
    setTimeout(open, delay);
    el.querySelectorAll('[data-popup-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(); });
  }
  document.querySelectorAll('[data-promo-popup]').forEach(ready);
})();

  } catch(e) { console.error(e); }
})();
})();
